<template>
  <b-link :to="{ name: 'dashboard' }">
    <img
      src="/logo.png"
      :width="imgWidth"
    >
  </b-link>
</template>
<script>
import { BLink } from 'bootstrap-vue';

export default {
  components: {
    BLink,
  },
  props: {
    imgWidth: {
      type: Number,
      default: 50,
    },
  },
};
</script>
